import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { AdminAuthProvider } from './context/AdminAuthContext';
import ActivationTracker from './pages/ActivationTracker';
import AdminWorkers from './pages/AdminWorkers';
import AllDevices from './pages/AllDevices';
import AllVenues from './pages/AllVenues';
import AnalyticsActivation from './pages/analytics/AnalyticsActivation';
import AnalyticsExport from './pages/analytics/AnalyticsExport';
import AnalyticsOperations from './pages/analytics/AnalyticsOperations';
import AnalyticsOverview from './pages/analytics/AnalyticsOverview';
import AnalyticsRevenue from './pages/analytics/AnalyticsRevenue';
import AnalyticsTipDistribution from './pages/analytics/AnalyticsTipDistribution';
import AnalyticsTraction from './pages/analytics/AnalyticsTraction';
import AuditLog from './pages/AuditLog';
import Events from './pages/Events';
import CommercialCommissions from './pages/CommercialCommissions';
import SellerPortalAdmin from './pages/SellerPortalAdmin';
import CommercialOffers from './pages/CommercialOffers';
import CreditNotes from './pages/CreditNotes';
import DeviceActivationSupport from './pages/DeviceActivationSupport';
import DeviceAppUpdatesPage from './pages/DeviceAppUpdatesPage';
import DeviceHealthDetail from './pages/DeviceHealthDetail';
import GlobalSettings from './pages/GlobalSettings';
import InvoiceDetails from './pages/InvoiceDetails';
import InvoiceList from './pages/InvoiceList';
import InvoiceMonitoring from './pages/InvoiceMonitoring';
import KioskMode from './pages/KioskMode';
import LegalDocuments from './pages/LegalDocuments';
import Login from './pages/Login';
import MediaAssets from './pages/MediaAssets';
import OperationalAlerts from './pages/OperationalAlerts';
import SafetyPayouts from './pages/SafetyPayouts';
import Overview from './pages/Overview';
import Plans from './pages/Plans';
import PlanFeatures from './pages/PlanFeatures';
import LegacyTenants from './pages/LegacyTenants';
import ProfileRoles from './pages/ProfileRoles';
import RemoteDeviceConfig from './pages/RemoteDeviceConfig';
import TenantManagement from './pages/TenantManagement';
import Tenants from './pages/Tenants';
import TipTransactions from './pages/TipTransactions';
import TipTransferDetails from './pages/TipTransferDetails';
import VenueCategories from './pages/VenueCategories';
import VenueDetail from './pages/VenueDetail';
import WorkerInvoices from './pages/WorkerInvoices';
import WorkerInvoicesWithReversals from './pages/WorkerInvoicesWithReversals';
import WorkerPayouts from './pages/WorkerPayouts';

function App() {
  return (
    <Router>
      <AdminAuthProvider>
        <div className="App">
          <Routes>
            {/* Public route - Login */}
            <Route path="/login" element={<Login />} />

            {/* Protected routes with AdminLayout */}
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/admin/overview" replace />} />
                      <Route path="/admin" element={<Navigate to="/admin/overview" replace />} />
                      <Route path="/admin/overview" element={<Overview />} />
                      <Route path="/admin/analytics" element={<Navigate to="/admin/analytics/overview" replace />} />
                      <Route path="/admin/analytics/overview" element={<AnalyticsOverview />} />
                      <Route path="/admin/analytics/traction" element={<AnalyticsTraction />} />
                      <Route path="/admin/analytics/revenue" element={<AnalyticsRevenue />} />
                      <Route path="/admin/analytics/activation" element={<AnalyticsActivation />} />
                      <Route path="/admin/analytics/operations" element={<AnalyticsOperations />} />
                      <Route path="/admin/analytics/tip-distribution" element={<AnalyticsTipDistribution />} />
                      <Route path="/admin/analytics/export" element={<AnalyticsExport />} />
                      <Route path="/admin/tenants" element={<Tenants />} />
                      <Route path="/admin/tenant/:tenantId" element={<TenantManagement />} />
                      <Route path="/admin/venue/:venueId" element={<VenueDetail />} />
                      <Route path="/admin/venues" element={<AllVenues />} />
                      <Route path="/admin/workers" element={<AdminWorkers />} />
                      <Route path="/admin/devices" element={<AllDevices />} />
                      <Route path="/admin/updates" element={<DeviceAppUpdatesPage />} />
                      <Route path="/admin/legal-documents" element={<LegalDocuments />} />
                      <Route path="/admin/global-settings" element={<GlobalSettings />} />
                      <Route path="/admin/kiosk-mode" element={<KioskMode />} />
                      <Route path="/admin/audit-log" element={<AuditLog />} />
                      <Route path="/admin/events" element={<Events />} />
                      <Route path="/admin/tip-transactions" element={<TipTransactions />} />
                      <Route path="/admin/tip-transactions/:paymentIntentId/transfers" element={<TipTransferDetails />} />
                      <Route path="/admin/invoices/monitoring" element={<InvoiceMonitoring />} />
                      <Route path="/admin/invoices/generate" element={<WorkerInvoices />} />
                      <Route path="/admin/invoices/:invoiceId" element={<InvoiceDetails />} />
                      <Route path="/admin/invoices" element={<InvoiceList />} />
                      <Route path="/admin/credit-notes" element={<CreditNotes />} />
                      <Route path="/admin/invoices/credit-notes" element={<WorkerInvoicesWithReversals />} />
                      <Route path="/devices/:deviceId/health" element={<DeviceHealthDetail />} />
                      <Route path="/admin/venue-categories" element={<VenueCategories />} />
                      <Route path="/admin/media" element={<MediaAssets />} />
                      <Route path="/admin/remote-device-config" element={<RemoteDeviceConfig />} />
                      <Route path="/admin/profile-roles" element={<ProfileRoles />} />
                      <Route path="/admin/plan-features" element={<PlanFeatures />} />
                      <Route path="/admin/commercial-offers" element={<CommercialOffers />} />
                      <Route path="/admin/plans" element={<Plans />} />
                      <Route path="/admin/legacy-tenants" element={<LegacyTenants />} />
                      <Route path="/admin/commercial-commissions" element={<CommercialCommissions />} />
                      <Route path="/admin/seller-portal" element={<SellerPortalAdmin />} />
                      <Route path="/admin/activation-tracker" element={<ActivationTracker />} />
                      <Route path="/admin/device-activation-support" element={<DeviceActivationSupport />} />
                      <Route path="/admin/operational-alerts" element={<OperationalAlerts />} />
                      <Route path="/admin/safety-payouts" element={<SafetyPayouts />} />
                      <Route path="/admin/worker-payouts" element={<WorkerPayouts />} />
                    </Routes>
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </AdminAuthProvider>
    </Router>
  );
}

export default App;
